<div class="m-3 p-3">
    <div class="row">
        <div class="d-flex mb-4">
            <div class="col-8 p-3">
                <h1 class="sub-header-title">
                    @if(data.component === 'properties') {
                        Select Insurance Policy for Property ID 
                        <ng-container *ngFor="let property of propertiesToUpdate">
                            - {{ property.property_id }}
                        </ng-container>
                    } @else {
                        Select Insurance Policy
                    }
                </h1>
            </div>
            @if(updatePropertyPolicy) {
                <div class="col-4 d-flex justify-content-end">
                    <mat-checkbox (change)="setSelectedPolicyAsPrimary($event)">
                        Set Policy as Primary?
                    </mat-checkbox>
                </div>
            }
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-12">
            <div class="d-flex flex-column">
                <div class="d-flex justify-content-center w-100">
                    <app-shared-policy-table
                        [dataSource]="dataSource"
                        [displayedColumns]="columns"
                        [component]="'Policies'"
                        [displayLoadingIndicator]="loading"
                        [hidePointer]="true"
                        [actionButtonText]="'Select'"
                        [propertyHasPrimaryPolicy]="propertyHasPrimaryPolicy"
                        (actionClickedEvent)="onViewRangesOpenClick($event)"
                        (selectPolicyClickedEvent)="onSelectPolicyClick($event)"
                    >
                    </app-shared-policy-table>
                </div>
            </div>
        </div>
    </div>
    @if(shouldShowRemovePolicyButton) {
        <div class="row mb-3">
            <div class="col-12">
                <h5 class="mx-3">
                    Shared Policy Table
                </h5>
                <div class="d-flex flex-column">
                    <div class="d-flex justify-content-center w-100">
                        <app-shared-policy-table
                            [dataSource]="policiesToRemoveDataSource"
                            [displayedColumns]="removePolicyColumns"
                            [component]="'Policies'"
                            [displayLoadingIndicator]="loading"
                            [hidePointer]="true"
                            [actionButtonText]="'Remove'"
                            [propertyHasPrimaryPolicy]="true"
                            (actionClickedEvent)="onViewRangesOpenClick($event)"
                            (selectPolicyClickedEvent)="onRemovePolicyClick($event)"
                        >
                        </app-shared-policy-table>
                    </div>
                </div>
            </div>
        </div>
    }
    <div class="mt-2 mb-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="cancelUpdatePolicy()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
    </div>
</div>